module.exports = __webpack_public_path__ + "static/media/ButtonsVersions_05.c6758eee.png";